import intlTelInput from 'intl-tel-input'

export default class InitFormValidation {
  constructor(form) {
    this.form = form
    this.numbersTested = []
    this.emailsTested = []
    this.phoneFields = {}
    this.setUpEventListeners()
    //TODO put conditional here to check if contains input[type=tel]
    if (form.find('input[type=tel]')) this.setUpPhoneValidation()
  }

  setUpEventListeners() {
    let _this = this
    this.form.on('change', 'select, input[type=radio], input[type=checkbox]', function () {
      event.stopImmediatePropagation()
      _this.validate($(this), function (isvalid) {})
    })
    this.form.on('input', 'input[type=text]', function () {
      event.stopImmediatePropagation()
      _this.validate($(this), function (isvalid) {})
    })
    this.form.on(
      'focusout',
      'input[type=text], input[type=tel], input[type=phone], input[type=email], textarea',
      function (event) {
        event.stopImmediatePropagation()
        _this.validate($(this), function (isvalid) {})
      }
    )
    this.form.on('click', '.select-item', function () {
      event.stopImmediatePropagation()
      _this.validate($(this).closest('div.select').find('select'), function (isvalid) {})
    })
    this.form.find('input, select, textarea').on('invalid', function (e) {
      event.stopImmediatePropagation()
      _this.validate($(this), function (isvalid) {})
      e.preventDefault()
    })
  }

  isValid(callback) {
    //loop through and check validity of each element
    let valid = true
    let formFields = this.form
      .find('input, textarea, select')
      .not(
        'input[type="hidden"], input[type="range"], input[type=text].select, input[type="submit"]'
      )
    let totalFormFields = formFields.length - 1
    formFields.each(
      function (index, _this) {
        this.validate($(_this), function (itemValid) {
          if (!itemValid) {
            valid = false
          }
          if (index === totalFormFields) {
            return callback(valid)
          }
        })
      }.bind(this)
    )
  }

  validate(_this, callback) {
    if (_this.is('[type=submit]')) return
    this.customFieldValidation(
      _this,
      function () {
        //first check the custom validation
        //then check normal fields
        let formValid = document.getElementById(_this.attr('id')).validity.valid
        if (!formValid) {
          this.makeInvalid(_this)
          return callback(formValid)
        }
        if (_this.val().length > 0) {
          this.makeValid(_this)
        } else {
          this.makeNeutral(_this)
        }
        return callback(formValid)
      }.bind(this)
    )
  }

  customFieldValidation(_this, callback) {
    if (typeof _this.attr('type') === 'undefined') return callback(false)

    if (
      _this.attr('type') != 'email' &&
      _this.attr('type') != 'tel' &&
      _this.attr('type') != 'checkbox'
    )
      return callback(false)

    //email
    if (_this.is('[type=email]')) {
      this.checkEmail(_this, function (isValid) {
        return callback(isValid)
      })
    }

    //phone
    if (_this.is('[type=tel]')) {
      this.checkPhone(
        _this,
        function (isValid) {
          return callback(isValid)
        }.bind(this)
      )
    }

    //checkbox
    if (_this.is('[type=checkbox]')) {
      this.checkBox(_this, function (isValid) {
        return callback(isValid)
      })
    }
  }

  checkBox(_this, callback) {
    //see if it has required class
    if ($(_this).attr('aria-required')) return callback(true)
    if ($(_this).closest('div.fieldset-content').find('input[type=checkbox]:checked').length > 0) {
      $(_this)
        .closest('div.fieldset-content')
        .find('input[type=checkbox]')
        .each(function () {
          document.getElementById($(this).attr('id')).setCustomValidity('')
        })
    } else {
      document.getElementById(_this.attr('id')).setCustomValidity('Please check this field.')
    }
    return callback(true)
  }

  checkEmail(_this, callback) {
    let email = _this.val()

    if (email.length === 0) return callback(false)

    //if we have already tested exptest, no need to retest
    if (this.emailsTested.indexOf(email) > -1) {
      document.getElementById(_this.attr('id')).setCustomValidity('')
      return callback(false)
    }

    this.showInputValidating(_this)
    this.checkEmailExperian(
      email,
      function (err, result) {
        this.hideInputValidating(_this)

        if (err) {
          document.getElementById(_this.attr('id')).setCustomValidity('')
          return callback(false)
        }

        if (result.certainty === 'unknown' || result.certainty === 'verified') {
          this.emailsTested.push(email)
          document.getElementById(_this.attr('id')).setCustomValidity('')

          return callback(false)
        } else {
          if (result.suggestions)
            //                    return callback(result.suggestions);
            document
              .getElementById(_this.attr('id'))
              .setCustomValidity('Please enter a valid email.')
          return callback(true)
        }
      }.bind(this)
    )
  }

  // Experian was removed; browser and intl-tel-input handle format validation.
  checkEmailExperian(email, callback) {
    callback(null, { certainty: 'unknown' })
  }

  checkMobileExperian(number, callback) {
    callback(null, { resultCode: 2 })
  }

  checkPhone(_this, callback) {
    if (_this.attr('type') != 'tel') {
      return callback(false)
    }
    if (_this.val().length === 0) {
      return callback(false)
    }
    if (!(_this.attr('id') in this.phoneFields)) {
      return callback(false)
    }
    //first validate with international phone numbers plugin
    let iti = this.phoneFields[_this.attr('id')]
    if (!iti.isValidNumber()) {
      let error = iti.getValidationError()
      let validationMessage = ''

      switch (error) {
        case 0:
          validationMessage = 'Enter a valid mobile number.'
          break
        case 1:
          validationMessage = 'Invalid country code'
          break
        case 2:
          validationMessage = 'The number entered is too short'
          break
        case 3:
          validationMessage = 'The number entered is too long'
          break
        case 4:
          validationMessage = 'Enter a valid mobile number'
          break
      }

      document.getElementById(_this.attr('id')).setCustomValidity(validationMessage)
      return callback(true)
      //return custom error
    }

    //it's passed, now check experian (only check if it's an australian number)
    let selectedCountry = iti.getSelectedCountryData()
    if (selectedCountry.iso2 != 'au') {
      return callback(false)
    }

    //it's valid and australian now lets check with experian

    let number = iti.getNumber()

    //empty number allowed
    if (!number) return callback(false)

    //we have already tested exptest, no need to retest
    if (this.numbersTested.indexOf(number) > -1) {
      document.getElementById(_this.attr('id')).setCustomValidity('')
      return callback(false)
    }
    this.showInputValidating(_this)
    this.checkMobileExperian(
      number,
      function (err, result) {
        this.hideInputValidating(_this)

        if (err) {
          document.getElementById(_this.attr('id')).setCustomValidity('')
          return callback(false)
        }

        if (parseInt(result.resultCode) === 3 || parseInt(result.resultCode) === 2) {
          //codes: 2 = absent, 3 = verified.
          //                self.mobileValidation.exptest = true;
          this.numbersTested.push(number)
          document.getElementById(_this.attr('id')).setCustomValidity('')
          return callback(false)
        } else {
          //                self.mobileValidation.exptest = false;
          document
            .getElementById(_this.attr('id'))
            .setCustomValidity('Please enter a valid mobile number.')
          return callback(true)
        }
      }.bind(this)
    )
  }

  setUpPhoneValidation() {
    $('head').append(
      "<link href='https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/16.0.2/css/intlTelInput.css' type='text/css' rel='stylesheet' />"
    )
  }

  setUpPhoneField(_this) {
    const config = {
      initialCountry: 'au',
      preferredCountries: ['au'],
      nationalMode: true,
      utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/16.0.2/js/utils.js',
    }
    const phoneFields = document.querySelectorAll(`#${_this.attr('id')}`)
    phoneFields.forEach(input => {
      this.phoneFields[input.id] = intlTelInput(input, config)
      //move the label
      $('#' + input.id)
        .closest('div.fsCell')
        .find('label')
        .detach()
        .appendTo(
          $('#' + input.id)
            .closest('div.fsCell')
            .find('.iti')
        )
      $('#' + input.id)
        .closest('div.fsCell')
        .find('div.fsSupporting')
        .detach()
        .appendTo(
          $('#' + input.id)
            .closest('div.fsCell')
            .find('.iti')
        )
    })
  }

  makeValid(_this) {
    let selectField = _this.closest('div').find('input[type=text].select')
    if (selectField.length > 0) selectField.addClass('is-success').removeClass('is-error')
    else if (_this.attr('type') === 'checkbox' || _this.attr('type') === 'radio')
      _this.closest('div.fieldset-content').addClass('is-success').removeClass('is-error')
    else _this.addClass('is-success').removeClass('is-error')

    this.hideError(_this)
  }

  makeNeutral(_this) {
    let selectField = _this.closest('div').find('input[type=text].select')
    if (selectField.length > 0) selectField.removeClass('is-success').removeClass('is-error')
    else if (_this.attr('type') === 'checkbox' || _this.attr('type') === 'radio')
      _this.closest('div.fieldset-content').find('input').removeClass('is-error')
    else _this.removeClass('is-success').removeClass('is-error')

    this.hideError(_this)
  }

  makeInvalid(_this) {
    let selectField = _this.closest('div').find('input[type=text].select')
    if (selectField.length > 0) {
      selectField.addClass('is-error')
    } else if (_this.attr('type') === 'checkbox' || _this.attr('type') === 'radio') {
      _this.closest('div.fieldset-content').removeClass('is-success').addClass('is-error')
    } else {
      _this.addClass('is-error').removeClass('is-success')
    }
    let msg = document.getElementById(_this.attr('id')).validationMessage
    this.showError(_this, msg)
  }

  showError(_this, msg) {
    let selectField = _this.closest('div').find('input[type=text].select')
    if (selectField.length > 0) {
      if (msg == '') {
        msg = 'Please select an item in the list.'
      }
      selectField.parent().find('.form__field-error').remove()
      selectField.parent().append(`<div class="form__field-error">${msg}</div>`)
      selectField.siblings('div.fsSupporting').hide()
    } else if (_this.attr('type') === 'checkbox' || _this.attr('type') === 'radio') {
      msg = 'Please check this field.'
      _this.closest('div.fieldset-content').find('.form__field-error, .ico').remove()
      _this.closest('div.fieldset-content').append(`<div class="form__field-error">${msg}</div>`)
    } else {
      _this.parent().find('.form__field-error, .ico').remove()
      _this
        .parent()
        .append(
          `<div class="form__field-error">${msg}</div><i class="ico ico--f-blocked ico--sm"></i>`
        )
    }
  }

  hideError(_this) {
    let selectField = _this.closest('div').find('input[type=text].select')
    if (selectField.length > 0) {
      selectField.parent().find('.form__field-error').remove()
      selectField.siblings('div.fsSupporting').show()
    } else if (_this.attr('type') === 'checkbox' || _this.attr('type') === 'radio') {
      _this.closest('div.fieldset-content').find('.form__field-error').remove()
    } else {
      _this.parent().find('.form__field-error, .ico').remove()
      _this.parent().append(`<i class='ico ico--f-tick ico--sm'></i>`)
    }
  }

  showInputValidating(_this) {
    _this.closest('div').find('.form__field-error, .ico, .ico--f-blocked').hide()
    _this.parent().append(`<i class='icon--loading'></i>`)
    _this.prop('disabled', true)
    this.form.find('input[type=submit], button[type=submit]').prop('disabled', true)
  }

  hideInputValidating(_this) {
    _this.prop('disabled', false)
    _this.parent().find('.icon--loading').remove()
    this.form.find('input[type=submit], button[type=submit]').prop('disabled', false)
  }
}
